module.exports = __webpack_public_path__ + "./docs/img/icon-folder.05a16707dc2dafa6365eaee3f0e23527.svg";